import React, {useEffect, useState} from 'react';
import numericFunction from "../../../utils/NumericFunction";
import {formatToPersianAddCommaNegativeToParentheses} from "../../../utils/CommaSeparator";

const ReviewAccountsPrintTwo = (props) => {

  const componentData = props.data.data
  const [makePage, setMakePage] = useState([])
  const format = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

  useEffect(() => {

    if (componentData.data.length > 19) {
      let i = 0;
      let mainData = []
      while (i < componentData.data.length) {

        let temp = []
        for (let j = 0; j < 19; j++) {
          temp.push(componentData.data[i])
          i = i + 1;
          if (i === componentData.data.length) {
            break;
          }
        }
        mainData.push(temp)
      }
      setMakePage(mainData)
    } else {
      let temp = []
      temp.push(componentData.data)
      setMakePage(temp)
    }
  }, [])

  let TBed = 0
  let TBedRemaining = 0
  let TBes = 0
  let TBesRemaining = 0

  try {
    return (
      <div className="main-print-factor">
        {makePage.length > 0 && makePage.map((v, index) => {
          let FBed = 0
          let FBedRemaining = 0
          let FBes = 0
          let FBesRemaining = 0
         return<>
            <div className="box-top-side-review-accounts">

              <div className="shop-name">
                <div className="name-side">
                  <h3>{componentData?.shopName}</h3>
                </div>
              </div>

              <div className="list-detail">
                <div className="inline-text">
                  <p>از تاریخ :</p>
                  <p>{numericFunction.e2p(componentData.startDate)}</p>
                </div>

                <div className="inline-text">
                  <p>از سند :</p>
                  <p>{numericFunction.e2p(componentData.firstId)}</p>
                </div>

                <div className="inline-text">
                  <p>تـاریـخ :</p>
                  <p>{new Date().toLocaleDateString("fa-ir", format)}</p>
                </div>

                <div className="inline-text">
                  <p>تا تاریخ :</p>
                  <p>{numericFunction.e2p(componentData.endDate)}</p>
                </div>

                <div className="inline-text">
                  <p>تا سند :</p>
                  <p>{numericFunction.e2p(componentData.lastId)}</p>
                </div>

                <div className="inline-text" style={{columnGap: '4px'}}>
                  <p>شماره صفحه :</p>
                  <p>{numericFunction.e2p(index + 1)}</p>
                  <p>از</p>
                  <p>{numericFunction.e2p(makePage.length)}</p>
                </div>
              </div>
            </div>

            <div className="box-table-side">

              <table className="solid-print-table">
                <thead>
                <tr>
                  <th className="th-bold">کد</th>
                  <th className="th-bold" style={{width: '180px'}}>عنوان</th>
                  <th className="th-bold">تاریخ سند</th>
                  <th className="th-bold">شماره سند</th>
                  <th className="th-bold">عطف</th>
                  <th className="th-bold">گردش بدهکار</th>
                  <th className="th-bold">گردش بستانکار</th>
                  <th className="th-bold">مانده بدهکار</th>
                  <th className="th-bold">مانده بستانکار</th>
                </tr>
                </thead>

                <tbody>
                {v.map((q) => {

                  const level_3 = q.level_3
                  const level_4 = q.level_4
                  const name_3 = q.name_3
                  const name_4 = q.name_4
                  const date = q.date
                  const documentId = q.documentId
                  const documentNumber = q.documentNumber
                  const bed = q.bed
                  const bes = q.bes
                  const bedRemaining = q.bedRemaining
                  const besRemaining = q.besRemaining
                  TBed += +q.bed
                  TBedRemaining += +q.bedRemaining
                  TBes += +q.bes
                  TBesRemaining += +q.besRemaining
                  FBed += +q.bed
                  FBedRemaining += +q.bedRemaining
                  FBes += +q.bes
                  FBesRemaining += +q.besRemaining

                  return <>
                    <tr style={{height: '20px'}}>
                      <th style={{borderBottom: '1px solid white'}}>
                        {numericFunction.e2p(level_3)}</th>
                      <th style={{borderBottom: '1px solid white'}}>
                        {numericFunction.e2p(name_3)}</th>
                      <th style={{borderBottom: '1px solid white'}}>
                        {numericFunction.e2p(date)}</th>
                      <th style={{borderBottom: '1px solid white'}}>
                        {numericFunction.e2p(documentId)}</th>
                      <th style={{borderBottom: '1px solid white'}}>
                        {numericFunction.e2p(documentNumber)}</th>
                      <th style={{borderBottom: '1px solid white'}}>
                        {formatToPersianAddCommaNegativeToParentheses(bed)}</th>
                      <th style={{borderBottom: '1px solid white'}}>
                        {formatToPersianAddCommaNegativeToParentheses(bes)}</th>
                      <th style={{borderBottom: '1px solid white'}}>
                        {formatToPersianAddCommaNegativeToParentheses(bedRemaining)}</th>
                      <th style={{borderBottom: '1px solid white'}}>
                        {formatToPersianAddCommaNegativeToParentheses(besRemaining)}</th>
                    </tr>
                    <tr style={{height: '20px'}}>
                      <th>{numericFunction.e2p(level_4)}</th>
                      <th>{numericFunction.e2p(name_4)}</th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                  </>
                })}
                </tbody>

                <tfoot>
                <tr style={{height: '20px'}}>
                  <th></th>
                  <th>{makePage[makePage.length - 1] === v ? "جمع کل" : "جمع صفحه"}</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>{makePage[makePage.length - 1] === v ?
                    formatToPersianAddCommaNegativeToParentheses(TBed) : formatToPersianAddCommaNegativeToParentheses(FBed) }</th>
                  <th>{makePage[makePage.length - 1] === v ?
                    formatToPersianAddCommaNegativeToParentheses(TBes) : formatToPersianAddCommaNegativeToParentheses(FBes)}</th>
                  <th>{makePage[makePage.length - 1] === v ?
                    formatToPersianAddCommaNegativeToParentheses(TBedRemaining) : formatToPersianAddCommaNegativeToParentheses(FBedRemaining)}</th>
                  <th>{makePage[makePage.length - 1] === v ?
                    formatToPersianAddCommaNegativeToParentheses(TBesRemaining) : formatToPersianAddCommaNegativeToParentheses(FBesRemaining)}</th>
                </tr>
                </tfoot>
              </table>
            </div>

            {makePage[makePage.length - 1] !== v && <div style={{pageBreakBefore: "always"}}></div>}
          </>
        } )}
      </div>
    );
  } catch (error) {
    return <>{error.toLocaleString()}</>
  }
};
export default ReviewAccountsPrintTwo;